import React from "react";
import { FooterEl } from "./AllData";

function Footer() {
  return (
    <div className="row footer mt-5">
      {FooterEl.map((el, index) => (
        <div
          className={ el.color + " col-md-6 col-sm-12 d-flex py-3 justify-content-end align-items-center"}
          key={index}
        >
          <div className="text-white m-0">{el.title}</div>
          <a className="btn btn-dark buttonFooter px-5 ml-5" href={el.location}>
            {" "}
            {el.button}
          </a>
        </div>
      ))}
    </div>
  );
}

export default Footer;
